var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"title":_vm.$t('logo.home'),"href":"/"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Vorarlberger Nachrichten")]),_vm._v(" "),_c('SiteLogo',{staticClass:"h-full w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }